var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 15H16.5V13.5C16.5 12.2574 15.4926 11.25 14.25 11.25C13.5333 11.25 12.8949 11.5851 12.4828 12.1072M12.75 15H5.25M12.75 15V13.5C12.75 13.0078 12.6552 12.5378 12.4828 12.1072M5.25 15H1.5V13.5C1.5 12.2574 2.50736 11.25 3.75 11.25C4.46671 11.25 5.10514 11.5851 5.51718 12.1072M5.25 15V13.5C5.25 13.0078 5.34482 12.5378 5.51718 12.1072M5.51718 12.1072C6.07013 10.7258 7.42111 9.75 9 9.75C10.5789 9.75 11.9299 10.7258 12.4828 12.1072M11.25 5.25C11.25 6.49264 10.2426 7.5 9 7.5C7.75736 7.5 6.75 6.49264 6.75 5.25C6.75 4.00736 7.75736 3 9 3C10.2426 3 11.25 4.00736 11.25 5.25ZM15.75 7.5C15.75 8.32843 15.0784 9 14.25 9C13.4216 9 12.75 8.32843 12.75 7.5C12.75 6.67157 13.4216 6 14.25 6C15.0784 6 15.75 6.67157 15.75 7.5ZM5.25 7.5C5.25 8.32843 4.57843 9 3.75 9C2.92157 9 2.25 8.32843 2.25 7.5C2.25 6.67157 2.92157 6 3.75 6C4.57843 6 5.25 6.67157 5.25 7.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.744010813ed51c69f1dd17f6c917507b.svg";
export { ForwardRef as ReactComponent };